import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@i18n';
import { PropertiesProvider, ModalProviders } from '@providers';
import { msalConfig } from '@utils';
import App from './App.tsx';
import { MapsApiProvider } from './components/GoogleMap/MapsApiProvider.tsx';

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <PropertiesProvider>
          <ModalProviders>
            <MapsApiProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </MapsApiProvider>
          </ModalProviders>
        </PropertiesProvider>
      </QueryClientProvider>
    </MsalProvider>
  </StrictMode>,
);
